<script>
    /**
     * ModalLetterTips
     */
    import { ModalHeader, ModalFooter, NormalButton } from 'southcn-mobile-ui';

    export default {
        alias: 'letterTips',
        defaultOptions () {
            return {
                title: '留言须知'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
        },
        data () {
            return {
                title: '',
            };
        },
        name: 'modal-letter-tips',
        methods: {
            onDestroy () {
                this.okCallback && this.okCallback();
                this.close();
            }
        },
        components: {
            ModalHeader,
            NormalButton,
            ModalFooter
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="normal-modal">
        <modal-header>{{title}}</modal-header>
        <div class="normal-modal__bd">
            <p>
                1.广东省政府“互联网+督查”平台旨在面向社会征集以下四个方面问题线索或意见建议：一是党中央、国务院和省委、省政府有关重大决策部署以及政策措施不落实或落实不到位的问题线索；二是省、市、县政府及其有关部门、单位不作为慢作为乱作为的问题线索；三是因政策措施不协调不配套不完善给市场主体和人民群众带来困扰的问题线索；四是改进政府工作的意见建议。企业和群众可以通过本平台围绕上述范围提供线索、反映问题、提出建议。</p>
            <p>
                2.为了您反映的问题能够得到及时有效处理，请您填写个人真实信息，如实反映有关情况，并对其真实性负责。我们将严格控制个人信息知悉范围。如您在有关选项中选择保密个人信息，您的联系方式将不会转给有关方面，这可能会影响您反映问题的解决效果。</p>
            <p>3.留言时请严格遵守《中华人民共和国宪法》等法律法规。</p>
            <p>4.为防止重复办理，请不要就同一事项反复留言。如您近期已向政府其他平台或渠道反映有关问题，且相关单位已经受理，希望您在办理结果出来之前暂不通过本平台重复反映。</p>
            <p>5.我们将对大家反映的问题线索和意见建议进行汇总整理，督促我省有关地市、部门处理，但无法保证对所有留言一一作出答复，请予谅解。</p>
            <p>6.本平台有可能将您反映的问题线索和意见建议及处理情况以适当方式向社会公开。如果您不希望公开，请在有关选项中作出声明，我们将充分尊重您的意愿。</p>
            <p>7.如您想反映贪污腐败、涉法涉诉、违法犯罪以及其他不在本平台征集范围内的问题，请依法依规向纪检监察机关、司法机关、公安机关、信访部门以及政府相关职能部门反映。</p>
        </div>
        <modal-footer>
            <normal-button @click.native="onDestroy();"
                           theme="primary"

            >阅读并已同意
            </normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>
    .normal-modal {
        .px2rem(top, 342) !important;
        margin-top: 0 !important;
        position: absolute;
        max-width: 80%;

        /deep/ .normal-modal__title {
            color: @primaryBg;
            font-weight: bold;
        }

        &__ft {
            .px2rem(padding-top, 60);
            .px2rem(padding-bottom, 60);
            .px2rem(padding-left, 35);
            .px2rem(padding-right, 35);

            &:after {
                display: none;
            }
        }

        &__bd {
            .px2rem(font-size, 26);
            text-indent: 2em;
            text-align: left;
            font-weight: 400;
            color: @otherNormalTitleClr;
        }
    }
</style>
